import React from "react";
import CASIndentMaster from "./Indent Reports/CASIndentMaster";
import CASLoading from "./Loading/CASLoading";
import CASUnloadingMaster from "./Unloading/CASUnloadingMaster";

const CASBody = ({ activePage }) => {
  return (
    <div className="ms-2 me-2">
      {activePage === "Indent Report" && <CASIndentMaster />}
      {activePage === "Loading" && <CASLoading />}
      {activePage === "Unloading" && <CASUnloadingMaster />}
    </div>
  );
};

export default CASBody;
